import { IRegisterValues } from "src/@types/auth";
import { Roles } from "src/@types/users";

export const formatFormValuesByRole = (
  values: IRegisterValues
): IRegisterValues => {
  const isAgent = values.role === Roles.AGENT;

  // create a copy of the object to avoid mutating the original
  const formattedValues = { ...values };

  if (isAgent) {
    // exclude irrelevant fields for agents
    const { reprecention_countries, industry, international, ...agentValues } =
      formattedValues;
    return agentValues;
  } else {
    // exclude irrelevant field for owners
    const { founding_docs, ...ownerValues } = formattedValues;
    return ownerValues;
  }
};
